import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';
import ReactGA from "react-ga4";

ReactGA.initialize("G-TRHCPKC4L2", {
  gaOptions: {
    debug_mode: true,
  },
});

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container); // Create a root
root.render(
    <React.StrictMode>
        <BrowserRouter>
        <App />
        </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();